import { IAction, IStore } from "store";
import { itemObjectHandlers } from "utils/item-object-handlers";
import objectFilter from "utils/object-filter";

import { DealAction } from "../../actions";
import { IFile, IFileMeta, IHandleItem } from "../../types";
import { reducer } from "../index";

reducer.createHandler(
  DealAction.GetFileMetaSuccess,
  (state, { payload }: IAction<IFileMeta>): IStore => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      fileMeta: payload
    }
  })
);

reducer.createHandler(
  DealAction.UpdateFileMetaSuccess,
  (state, { payload: { id, ...rest } }: IAction<Partial<IFileMeta>>) =>
    state.dealModule.fileMeta.id === id
      ? {
          ...state,
          dealModule: {
            ...state.dealModule,
            fileMeta: { ...state.dealModule.fileMeta, ...rest }
          }
        }
      : state
);

reducer.createHandler(DealAction.InvalidateFileMeta, (state) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    fileMeta: {}
  }
}));

// branches structure
reducer.createHandler(DealAction.GetFilesSuccess, (state, { payload }: IAction<Record<number, IFile>>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    files: payload
  }
}));

reducer.createHandler(DealAction.HandleFileSuccess, (state, { payload }: IAction<IHandleItem<IFile>>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    files: itemObjectHandlers[payload.event](payload.item, state.dealModule.files)
  }
}));

reducer.createHandler(DealAction.UploadFundFilesSuccess, (state, { payload }: IAction<IFile[]>) => {
  return {
    ...state,
    dealModule: {
      ...state.dealModule,
      files: {
        ...state.dealModule.files,
        ...payload.reduce((acc, item) => {
          return { ...acc, [item.id]: item };
        }, {})
      }
    }
  };
});

reducer.createHandler(DealAction.RemoveFilesFromStore, (state, { payload }: IAction<number[]>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    files: objectFilter(state.dealModule.files, (file) => !payload.includes(file.id))
  }
}));

reducer.createHandler(DealAction.GetDocumentTypesSuccess, (state, { payload }: IAction<string[]>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    documentTypes: payload
  }
}));
